export default "__VITE_ASSET__M$2U$fNF__"